package com.tovtalk.domain.usecase.post

import com.tovtalk.domain.entity.FeedPage
import com.tovtalk.domain.entity.DomainResult
import com.tovtalk.domain.repository.PostRepository

/**
 * Get Discover Feed Use Case (v2 — cursor pagination)
 */
class GetDiscoverPostsUseCase(
    private val postRepository: PostRepository
) {
    suspend operator fun invoke(
        cursor: String? = null,
        limit: Int = 15
    ): DomainResult<FeedPage> {
        return postRepository.getDiscoverFeed(cursor, limit)
    }
}
